'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateFitnessActivity = exports.createFitnessActivity = exports.fetchFitnessActivities = exports.deserializeFitnessActivity = undefined;
exports.deleteFitnessActivity = deleteFitnessActivity;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _uuid = require('uuid');

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _units = require('../../../utils/units');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializeFitnessActivity = exports.deserializeFitnessActivity = function deserializeFitnessActivity() {
  var activity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return {
    calories: activity.calories,
    campaign: activity.campaign_uid,
    charity: activity.charity_uid,
    coordinate: activity.coordinate,
    createdAt: activity.created_at,
    deleted: activity.deleted,
    description: activity.description,
    distance: activity.distance_in_meters,
    duration: activity.duration_in_seconds,
    elevation: activity.elevation_in_meters,
    elevationSeries: activity.elevation_series,
    flagged: activity.flagged,
    groups: activity.page_groups,
    id: activity.id,
    manual: activity.manual,
    mapUrls: activity.map_urls,
    page: activity.page_id,
    polyline: activity.polyline,
    public: activity.public,
    source: activity.source,
    sourceUrl: activity.source_url,
    startedAt: activity.started_at,
    team: activity.team_id,
    title: activity.caption,
    trainer: activity.trainer,
    type: activity.type,
    uid: activity.uid,
    virtual: activity.virtual
  };
};

var fetchFitnessActivities = exports.fetchFitnessActivities = function fetchFitnessActivities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  var mappings = {
    campaign: 'campaign_id',
    charity: 'charity_id',
    page: 'page_id',
    team: 'team_id',
    type: 'type',
    index: 'page'
  };

  return (0, _client.get)('api/v2/search/fitness_activities', params, { mappings: mappings }).then(function (response) {
    return response.fitness_activities;
  });
};

var createFitnessActivity = exports.createFitnessActivity = function createFitnessActivity(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? (0, _params.required)() : _ref$type,
      calories = _ref.calories,
      caption = _ref.caption,
      coordinates = _ref.coordinates,
      description = _ref.description,
      _ref$distance = _ref.distance,
      distance = _ref$distance === undefined ? 0 : _ref$distance,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 0 : _ref$duration,
      durationUnit = _ref.durationUnit,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === undefined ? 0 : _ref$elevation,
      elevationSeries = _ref.elevationSeries,
      elevationUnit = _ref.elevationUnit,
      _ref$manual = _ref.manual,
      manual = _ref$manual === undefined ? true : _ref$manual,
      pageId = _ref.pageId,
      _ref$startedAt = _ref.startedAt,
      startedAt = _ref$startedAt === undefined ? (0, _moment2.default)().toISOString() : _ref$startedAt,
      trainer = _ref.trainer,
      title = _ref.title,
      _ref$uid = _ref.uid,
      uid = _ref$uid === undefined ? (0, _uuid.v4)() : _ref$uid,
      unit = _ref.unit,
      virtual = _ref.virtual,
      _ref$visible = _ref.visible,
      visible = _ref$visible === undefined ? true : _ref$visible;
  return (0, _client.post)('/api/v2/fitness_activities?access_token=' + token, {
    calories: calories,
    caption: title || caption || description,
    coordinates: coordinates,
    distance_in_meters: (0, _units.convertToMeters)(distance, unit),
    duration_in_seconds: (0, _units.convertToSeconds)(duration, durationUnit),
    elevation: (0, _units.convertToMeters)(elevation, elevationUnit || unit),
    manual: manual,
    page_id: pageId,
    public: visible,
    started_at: startedAt,
    trainer: trainer,
    type: type,
    uid: uid,
    virtual: virtual
  });
};

var updateFitnessActivity = exports.updateFitnessActivity = function updateFitnessActivity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  var _ref2 = arguments[1];
  var _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token,
      type = _ref2.type,
      duration = _ref2.duration,
      manual = _ref2.manual,
      startedAt = _ref2.startedAt,
      uid = _ref2.uid,
      visible = _ref2.visible,
      calories = _ref2.calories,
      caption = _ref2.caption,
      coordinates = _ref2.coordinates,
      description = _ref2.description,
      distance = _ref2.distance,
      distanceInMeters = _ref2.distanceInMeters,
      elevationSeries = _ref2.elevationSeries,
      pageId = _ref2.pageId,
      trainer = _ref2.trainer,
      unit = _ref2.unit,
      virtual = _ref2.virtual;
  return (0, _client.put)('/api/v2/fitness_activities/' + id + '?access_token=' + token, {
    calories: calories,
    caption: caption,
    coordinates: coordinates,
    description: description,
    distance_in_meters: distanceInMeters,
    distance: distance,
    duration_in_seconds: duration,
    elevation_series: elevationSeries,
    manual: manual,
    page_id: pageId,
    public: visible,
    started_at: startedAt,
    trainer: trainer,
    type: type,
    uid: uid,
    unit: unit,
    virtual: virtual
  });
};

function deleteFitnessActivity(params) {
  var id = void 0,
      token = void 0;

  if ((0, _params.isParamsObject)(arguments)) {
    id = params.id;
    token = params.token;
  } else {
    id = arguments[0];
    token = arguments[1];
  }

  return (0, _client.destroy)('/api/v2/fitness_activities/' + id + '?access_token=' + token);
}